import { render, staticRenderFns } from "./SemifinishedproductoverviewPage.vue?vue&type=template&id=06585689"
import script from "./SemifinishedproductoverviewPage.vue?vue&type=script&lang=js"
export * from "./SemifinishedproductoverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports